<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('Transferlist.title')}}</strong>
                <!--<span class="float-right">{{$t('InvoiceOutbounds.text')}}</span>-->
                <div class="float-right">
                  <!--<router-link v-if="HelperRole.hasRights(state, [14],[16])" :to="{ path: '/invoiceoutbounds'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceOutbounds.new')}}</router-link>-->

                  <!--<router-link :to="{ path: '/invoiceoutbounds'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceOutbounds.new')}}</router-link>-->
                </div>
              </div>
              <div class="card-body card-block fColumn fColumn">
                <!--<div class="alert alert-warning">{{ $t('Transferlist.attentiontext') }}</div>-->


                <!--<router-link :to="{ path: '/invoiceoutboundnavrefresh'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceOutbounds.invoiceoutboundnavrefresh')}}</router-link>-->
                <!--<hr>-->

                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="select_year" class=" form-control-label">{{$t('selsells.selectYear')}}</label></div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<select id="select_year" v-model="selectedYear" class="form-control" name="selectedYear">-->
                <!--<option v-for="yearOption in yearOptions" :value="yearOption.value">{{yearOption.text}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="select_month" class=" form-control-label">{{$t('selsells.selectMonth')}}</label></div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<select id="select_month" v-model="selectedMonth" class="form-control" name="selectedMonth">-->
                <!--<option v-for="monthOption in monthOptions" :value="monthOption.value">{{monthOption.text}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--</div>-->

                <div class="row form-group">
                  <div class="col col-md-3"><label class=" form-control-label">{{$t('Transferlist.textOptions')}}</label></div>
                  <div class="col col-md-9">

                    <div class="form-check">
                      <div class="radio">
                        <label for="expired" class="form-check-label ">
                          <input type="radio" id="expired" value="expired" v-model="text" checked class="form-check-input">
                          {{$t('Transferlist.texts.expired')}}
                        </label>
                      </div>
                      <div class="radio">
                        <label for="next7days" class="form-check-label ">
                          <input type="radio" id="next7days" value="next7days" v-model="text" checked class="form-check-input">
                          {{$t('Transferlist.texts.next7days')}}
                        </label>
                      </div>
                      <div class="radio">
                        <label for="next14days" class="form-check-label ">
                          <input type="radio" id="next14days" value="next14days" v-model="text" checked class="form-check-input">
                          {{$t('Transferlist.texts.next14days')}}
                        </label>
                      </div>
                      <div class="radio">
                        <label for="date" class="form-check-label ">
                          <input type="radio" id="date" value="date" v-model="text" checked class="form-check-input">
                          {{$t('Transferlist.texts.date')}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <template v-if="text==='date'">

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_from" class=" form-control-label">{{ $t('Transferlist.dt_from') }}
                      <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_from" name="data.dt_from" v-model="data2.dt_from" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Transferlist.dt_from')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_from')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_to" class=" form-control-label">{{ $t('Transferlist.dt_to') }}
                      <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_to" name="data.dt_to" v-model="data2.dt_to" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Transferlist.dt_to')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_to')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                </template>

                <!-- -{{showDateCloseSelector}}- -->
                <!--<div class="row form-group" v-if="showDateCloseSelector">-->
                <!--<div class="col col-md-3"><label for="dt_to" class=" form-control-label">{{ $t('Transferlist.dateCloseSelector') }}-->
                <!--<span class="validatorrequired">({{ $t('validator.required') }})</span></label>-->
                <!--</div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<InputText type="DatetimepickerBp"-->
                <!--id="dateCloseSelector" name="dateCloseSelector" v-model="dateCloseSelector" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""-->
                <!--:title="$t('Transferlist.dateCloseSelector')"-->
                <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('dateCloseSelector')"/>-->
                <!--<small class="form-text text-muted"></small>-->
                <!--</div>-->
                <!--</div>-->

                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data" :options="options"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import moment from 'moment';
  import InputText from '@/components/InputText.vue';

  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';

  export default {
    name: 'TransferList',
    data() {
      const modul = this;
      // "id","id_company","text"
      return {
        data2: {
          dt_from: moment.utc().local().add(-1, 'month').format('YYYY-MM-DD'),
          dt_to: moment.utc().local().format('YYYY-MM-DD'),
        },
        year: "",
        yearOptions: [],
        month: "",
        text: "expired",

//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,
//        yearOptions: "",
//        monthOptions: "",
//
//        selectedYear: "",
//        selectedMonth: "",
//        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

        data: [],
        options: {
          exportToXlsKey: "Transferlist.exportToXls",
          exportToXlsKeySelected: "Transferlist.exportToXlsSelected",
//          exportToXlsDefaultSortKey: "from_name", // 20230502 question
//          exportToXlsDefaultSortDirection: "asc",
          exportToXlsDefaultSortConvertType: "lowercase",
          operationstitle: "Transferlist.operationstitle",
          operationfunctions: [
            {
              key: "id",
              title: "Transferlist.setTransferedAllSelected",
              displaytype: "button",
              cbfn: modul.cbfnCloseall
            }
            , {
              key: "id",
              title: "Transferlist.setTransferedAllSelectedDate",
              displaytype: "buttonclosedate",
              dateSelectorTitle: "Transferlist.dateSelector",
              cbfn: modul.cbfnCloseallDate
            }
          ]

        },
        head: [
          {
            key: "id",
            title: "",
            celltype: "mark"
          }
          ,
          {
            modulname: "InvoiceOutbounds",
            title: "InvoiceOutbounds.dttitle",
            data: "id",
            link: true,
            linkurl: "sbinvoiceinbound",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // InvoiceOutbounds.linktext
          }


          ,
          {
            xlsfield: true,
            key: "identifier",
            title: "Document.identifier",
            searchField: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              // a sumnum a képek hozzá feltöltött képek száma
              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
                return "rowgreen";
              }
              if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
                return "rowyellow";
              }
              return "rowred";

//              if (HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                  return "rowgreen";
//                }
//                if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                  return "rowyellow";
//                }
//                return "rowred";
//              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
//                  return "rowgreen";
//                }
//                if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
//                  return "rowyellow";
//                }
//                return "rowred";
////                return "";
//
//              }
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "dt_make",
            title: "InvoiceInbounds.dt_make",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "dt_completion",
            searchField: true,
            title: "InvoiceInbounds.dt_completion",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "dt_paymentdeadline",
            searchField: true,
            title: "InvoiceInbounds.dt_paymentdeadline",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "dt_needtransfer",
            title: "InvoiceInbounds.dt_needtransfer",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
//            render: function (dataRowheadRowkey, type, dataRow, meta) {
//              return "dt_needtransfer"; // modul.$t("gg."+dt_needtransfer);
//            },

          }
//          , {
//            xlsfield: true,
//            key: "dt_transfer",
//            title: "InvoiceInbounds.dt_transfer",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//              return "text-nowrap";
//            },
//          }
          , {
            xlsfield: true,
            searchField: true,
            key: "from_name",
            title: "InvoiceInbounds.from_name",
            sortConvertType: "lowercase",
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "from_bank_account",
            title: "InvoiceInbounds.from_bank_account",
          }
          , {
            xlsfield: true,
            xlsfieldNumber: true,
            xlsrender: false,
            searchField: true,
            key: "price_sum",
            title: "InvoiceInbounds.price_sum_act_dev",
            sortConvertType: "number",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              let user_sumprice_huf_number_of_decimals = (Number(modul.user_sumprice_huf_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_huf_number_of_decimals) : 0;
              let user_sumprice_eur_number_of_decimals = (Number(modul.user_sumprice_eur_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_eur_number_of_decimals) : 2;
              let user_sumprice_usd_number_of_decimals = (Number(modul.user_sumprice_usd_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_usd_number_of_decimals) : 2;

              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_huf_number_of_decimals) {
                user_sumprice_huf_number_of_decimals = modul.state.usersettings.user_sumprice_huf_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_eur_number_of_decimals) {
                user_sumprice_eur_number_of_decimals = modul.state.usersettings.user_sumprice_eur_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_usd_number_of_decimals) {
                user_sumprice_usd_number_of_decimals = modul.state.usersettings.user_sumprice_usd_number_of_decimals
              }
              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum"], user_sumprice_huf_number_of_decimals)
              } else if (dataRow.currency === "EUR") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum_currency"], user_sumprice_eur_number_of_decimals)
              } else if (dataRow.currency === "USD") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum_currency"], user_sumprice_usd_number_of_decimals)
              }
              return ret;
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = dataRow["price_sum"]
              } else if (dataRow.currency === "EUR") {
                ret = dataRow["price_sum_currency"]
              } else if (dataRow.currency === "USD") {
                ret = dataRow["price_sum_currency"]
              }
              return ret;
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "currency",
            title: "InvoiceInbounds.currency",
          },
          {
            key: "id",
            title: "InvoiceInbounds.settransfered",
            data: "user2company_id_user",
            linkclass: "text-nowrap btn btn-info",
            linktext: "InvoiceInbounds.payed",
            linkiconclass: "menu-iconfafa-users",
            displayFn: function (data, type, row, meta) { // data, type, row, meta
              let hasWf = false;
              if (row.wf_status && row.wf_status === "ACCEPTED") {
                hasWf = true;
              }
              let hasSum = false;
              if (HelperRole.hasRights(modul.state, [15], false)) {
                if (row.sumnum && !isNaN(Number(row.sumnum)) && Number(row.sumnum) > 0) { //&& row.navdata // kézi felvitel esetén nem lehetne kifizetni
                  hasSum = true;
                }
              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
                if (row.sumnum && !isNaN(Number(row.sumnum)) && Number(row.sumnum) > 0) { //
                  hasSum = true;
                }
              }
              if (hasWf && hasSum) {
                return true;
              } else {
                return false;
              }
            },
            linkfn: function (e, data, type, row, meta) { //e, data, type, row, meta
              return modul.handlePayedHandler(e, data, type, row, meta);
            }
          }
          , {
            key: "text2",
            title: "Document.text2",
            xlsfield: true,
            classth: "d-none",
            classtd: "d-none",
          }

//          , {
//            key: "to_name",
//            title: "Document.to_businesspartnername",
//          }
//          , {
//            key: "deleted",
//            title: "global.deleted",
//            searchField: true
//          }


        ]
        , breadcrumbstitle: 'InvoiceOutbounds.title'
        , breadcrumbsData: [
          {
            'title': "InvoiceOutbounds.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , timer: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },
      'data2.dt_from': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },
      'text': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
              if(newVal === "date"){
                modul.$validator.validateAll().then((result) => {
                  if (result) {
                    modul.getElements();
                  }
                });
              } else {
                    modul.getElements();
              }
          }
        }, 1000);
      },
      'data2.dt_to': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [19, 20])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        this.setYearsMonths();
//        modul.getElements();

      },
      setYearsMonths(){
        const modul = this;
        const actualYears = [moment().get("year"), moment().get("year") - 1, moment().get("year") - 2];
        const actualMonth = moment().get("month") + 1;
//                const actualYears = [moment.utc().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
//                const actualMonth = moment.utc().get("month") + 1;
        const yearOptions = [];
        Array.prototype.forEach.call(actualYears, function (e) {
          yearOptions.push({'value': e, 'text': e});
        });
        const selectedYear = "" + actualYears[0];
        const selectedMonth = "" + actualMonth;
        modul.yearOptions = yearOptions;
//                modul.year = selectedYear;
//                modul.month = selectedMonth;

        const actualDt2 = moment();
//        actualDt2.subtract('months', 1);
//        actualDt2.set('date', 1);
//        actualDt2.set('hour', 0);
//        actualDt2.set('minute', 0);
//        actualDt2.set('second', 0);
//        actualDt2.set('millisecond', 0);
        modul.data2.dt_from = actualDt2.clone().subtract('months', 3).format('YYYY-MM-DD HH:mm:ss');
        modul.data2.dt_to = actualDt2.clone().format('YYYY-MM-DD HH:mm:ss'); // .endOf('month')
        modul.year = actualDt2.get("year");
        modul.month = actualDt2.get("month");
      },
      getElements(){
        const modul = this;
        const data = {};
        data.text = modul.text;
        data.additionalimages = true;
        if (modul.text === "date") {
          data.dt_from = modul.data2.dt_from;
          data.dt_to = modul.data2.dt_to;
        } else if (modul.text === "expired") {
        } else if (modul.text === "next7days") {
          data.dt_to = moment().add(7, 'day').format('YYYY-MM-DD');
        } else if (modul.text === "next14days") {
          data.dt_to = moment().add(14, 'day').format('YYYY-MM-DD');
        } else
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getTransferList({id_company: modul.$store.state.id_company, data: data}).then(function (res) {
          if (res && res.result) {
            modul.data = Array.from(res.data);
          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      handlePayedHandler(event, data, type, row, meta){
        console.log(event, row);
        const modul = this;

        const fnCb = function () {
          const dt_transfer = moment().format('YYYY-MM-DD');
          const id = row.id;
          console.log(JSON.stringify(row));
          const postData = {
            dt_transfer: dt_transfer,
            transfered: "1"
          }
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveInvoiceInboundTransfered({id_company: modul.$store.state.id_company, id: id, data: postData}).then(function (res) {
            if (res && res.result) {
              if (Helper.Number(res.data.transfered) === 1) {
                modul.getElements();
              }
            }
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(2000));

          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
        };
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("InvoiceInbounds.settransfered_question"),
          tmsgText: "",
          fnCancel: function () {
          },
          fnConfirm: function () {
            fnCb()
          }
        });


      },
      cbfnCloseall(event, selectedRowIds){
        const modul = this;
        const fnCb = function () {
          const dt_transfer = moment().format('YYYY-MM-DD');
//          const id = row.id;
          console.log(JSON.stringify(selectedRowIds));
          const postData = {
            selectedRowIds: selectedRowIds,
            fieldData: {
              dt_transfer: dt_transfer,
              transfered: "1"
            }
          };
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveInvoiceInboundsTransfered({id_company: modul.$store.state.id_company, data: postData}).then(function (res) {
            if (res && res.result) {
              modul.getElements();
            }
            console.log(res);
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(2000));

          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
        }
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("Transferlist.settransfered_question"),
          tmsgText: "",
          fnCancel: function () {
          },
          fnConfirm: function () {
            fnCb()
          }
        });
      },
      cbfnCloseallDate(event, selectedRowIds, date){
        const modul = this;
        const fnCb = function () {
          const dt_transfer = date;
          console.log(JSON.stringify(selectedRowIds));
          const postData = {
            selectedRowIds: selectedRowIds,
            fieldData: {
              dt_transfer: dt_transfer,
              transfered: "1"
            }
          }
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveInvoiceInboundsTransfered({id_company: modul.$store.state.id_company, data: postData}).then(function (res) {
            if (res && res.result) {
              modul.getElements();
            }
            console.log(res);
            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(2000));

          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
        }
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("Transferlist.settransfered_question"),
          tmsgText: "",
          fnCancel: function () {
          },
          fnConfirm: function () {
            fnCb()
          }
        });

      },

    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      InputText,
      AlertInPage,
    },
  };
</script>








